import { render, staticRenderFns } from "./SupplierReport.vue?vue&type=template&id=233de1cb&"
import script from "./SupplierReport.vue?vue&type=script&lang=js&"
export * from "./SupplierReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Ramon/PROYECTOS/JuanGabriel_POS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('233de1cb')) {
      api.createRecord('233de1cb', component.options)
    } else {
      api.reload('233de1cb', component.options)
    }
    module.hot.accept("./SupplierReport.vue?vue&type=template&id=233de1cb&", function () {
      api.rerender('233de1cb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/admin/SupplierReport.vue"
export default component.exports